module.exports = __webpack_public_path__ + "static/media/v4.c9d2e791.mp4";